import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EInfrastructureActionTypes {
  SetRating = 'NEW_REVIEW/INFRASTRUCTURE_RATING/SET',
}

export type TSetInfrastructureRating = ITypedReduxAction<EInfrastructureActionTypes.SetRating, number>;

/**
 * Redux action, который записывает в store общий рейтинг инфраструктуры нового отзыва
 * @param rating number
 */
export const setInfrastructureRating: (rating: number) => TSetInfrastructureRating = actionGenerator<
  EInfrastructureActionTypes.SetRating,
  number
>(EInfrastructureActionTypes.SetRating);
